<template>
    <div>
        <p v-for="(line, index) in lines" :key="`line_${index}`">{{ line }}</p>
    </div>
</template>
<script>
export default {
    props: {
        text: {
            type: String,
            required: true
        }
    },
    computed: {
        lines() {
            // split text into lines
            return this.text.split(/\r?\n/g);
        }
    }
};
</script>



// WEBPACK FOOTER //
// MultiLineText.vue?5d8e1c32